<template>
  <div>
    <el-col :span="24">
      <div>
        <el-table
          :data="tableData"
          :height="tableHeight(-12)"
          size="mini"
          stripe
          border
          style="width: 100%;">
          <el-table-column
            prop="paraname"
            align="left" header-align="center"
            label="名称">
          </el-table-column>
          <el-table-column
            label="版本号"
            align="left">
            <template slot-scope="scope">
            {{showContent(scope.row.paracontent,'newVer')}}
            </template>
          </el-table-column>
          <el-table-column
            label="本次更新内容"
            align="left" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{showContent(scope.row.paracontent,'strNewFunctionDes2')}}
            </template>
          </el-table-column>
          <el-table-column
            label="文件大小"
            align="left" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{showContent(scope.row.paracontent,'wgtsize')}}
            </template>
          </el-table-column>
          <el-table-column
            label="更新日期"
            align="left" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{showContent(scope.row.paracontent,'updateDate')}}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="150">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)">编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <appUpdateEdit ref="appUpdateEdit" @bindGuid="bindGrid"></appUpdateEdit>
    </el-col>

  </div>
</template>

<script>
  import appUpdateEdit from '@/components/sysmanage/parametermaintain/appUpdateEdit';
  import {globallist} from '@/api/set/parameter';

  export default {
    name: 'appupdateList',
    data() {
      return {
        formLabelWidth: '120px',
        dialogFormVisible: false,
        tenantid: '',
        independentserial: '',
        loading: true,
        tableData: [],
        pos: 0
      }
    },
    methods: {
      showContent(con,item){
        return JSON.parse(con)[item];
      },
      //由于数据是动态的，所以页面加载时需要调用下面的方法，根据后台数据处理以知道要合并的行/列
      //得到的spanArr数组表示某一行所需要合并的列数
      handleEdit(index, row) {
        this.$refs.appUpdateEdit.show()
        this.$refs.appUpdateEdit.initData(row)
      },
      bindSelect(tenantid) {
        this.bindGrid();
      },
      bindGrid() {
        globallist({
          paragroup: 'appupdate',
        }).then(response => {
          this.tableData = response.data.obj
        }).catch((error) => {
          console.log(error)
        });
      },

    },
    mounted() {
      this.bindGrid();
    },
    components: {
      appUpdateEdit
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/sysmanage/parametermaintain/appupdateList.vue